export interface HrEmployeeFilters {
  owningCompanyId?: number;
  searchText?: string;
  employeeNumber?: string;
  workerCategory?: string;
  employeeType?: string;
  status?: string;
  departmentId?: number;
  positionId?: number;
  managerEmployeeId?: number;
  workLocation?: string;
  driverLinked?: boolean;
  customerLinked?: boolean;
  page?: number;
  pageSize?: number;
}

export interface HrEmployee {
  employeeId?: number;
  owningCompanyId?: number;
  employeeNumber?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  customerId?: number;
  customerName?: string;
  imageUrl?: string;
  workerCategory?: string;
  employeeType?: string;
  status?: string;
  departmentId?: number;
  departmentName?: string;
  jobId?: number;
  jobName?: string;
  positionId?: number;
  positionName?: string;
  managerEmployeeId?: number;
  managerEmployeeName?: string;
  workLocationId?: number;
  workLocation?: string;
  startDate?: string;
  endDate?: string;
  notes?: string;
  biometricProviderCode?: string;
  biometricEmployeeIdentifierKey?: string;
  driverLinked?: boolean;
  customerLinked?: boolean;
  createdAt?: string;
  updatedAt?: string;
  identityLinks?: HrIdentityLink[];
  lifecycleEvents?: HrLifecycleEvent[];
  employmentRecords?: HrEmploymentRecord[];
}

export interface HrIdentityLink {
  identityLinkId?: number;
  employeeId?: number;
  linkType?: 'CUSTOMER' | 'DRIVER' | string;
  linkedEntityId?: number;
  linkedDisplayName?: string;
  migrationSource?: string;
  active?: boolean;
  linkedAt?: string;
  unlinkedAt?: string;
}

export interface HrLifecycleEvent {
  lifecycleEventId?: number;
  employeeId?: number;
  eventType?: string;
  eventTitle?: string;
  eventDescription?: string;
  oldValue?: string;
  newValue?: string;
  metadataJson?: string;
  createdByCustomerId?: number;
  createdAt?: string;
}

export interface HrEmploymentRecord {
  employmentRecordId?: number;
  employeeId?: number;
  departmentId?: number;
  jobId?: number;
  positionId?: number;
  managerEmployeeId?: number;
  employeeType?: string;
  workLocation?: string;
  effectiveFrom?: string;
  effectiveTo?: string;
  active?: boolean;
  reason?: string;
  createdAt?: string;
}

export interface HrWorkerCategory {
  workerCategoryId?: number;
  owningCompanyId?: number;
  categoryCode?: string;
  categoryName?: string;
  active?: boolean;
  systemCategory?: boolean;
  description?: string;
}

export const HR_EMPLOYEE_STATUSES = ['DRAFT', 'ONBOARDING', 'ACTIVE', 'SUSPENDED', 'TERMINATED'];

export const HR_EMPLOYEE_TYPES = ['FULL_TIME', 'PART_TIME', 'CONTRACT', 'TEMPORARY', 'INTERN', 'OUTSOURCED'];

